<template>
  <v-app>
    <v-progress-linear v-if="$store.state.progressLoading" height="2" indeterminate color="indigo" absolute
      style="top:0px;z-index:1000"></v-progress-linear>
    <div class="bg-design-box bg-design-2"></div>
    <div :class="`bg-design-box bg-design-3 bgcolor-${($route.meta || {}).color}-20`"></div>

    <div v-if="!clientload" class="all-height d-flex align-center justify-center">
      <div>
        <div class="project-title pb-5 text-center">
          <img src="/img/consark/ConsarkLogo.svg" class="logo-image" alt="logo-image" />
        </div>
        <loader />
      </div>
    </div>
    <v-layout class="d-flex flex-column">
      <v-app-bar height="64" max-height="64"
        class="d-flex justify-space-between w-100 app-bar-bg align-center shadow-off">
        <div class="d-flex">
          <div class="d-flex align-center justify-start">
            <template v-if="!logoImageError">
              <img width="100%" :aspect-ratio="16 / 9" src="/img/consark/ConLogo.svg" alt="back-ground image"
                @error="logoImageError = true" />
            </template>
            <v-icon v-else style="font-size:32px; color:#6B67CE">mdi-image-off-outline</v-icon>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex">
          <div class="d-flex align-center">
            <div v-if="($route.meta || {}).showclients !== false && showHeaderAction">
              <client-selector v-model="selectedclient" :clients="$store.state.clientlist" prepend-icon="mdi-domain"
                append-icon="mdi-chevron-down" />
            </div>
            <div style="height: 24px; display: flex; align-items: center; margin: 0 16px;">
              <div style="background: var(--Purple-300, #BDBCE6); width: 1px; height: 24px;"></div>
            </div>
            <v-tooltip left content-class="tooltip-left">
              <template v-slot:activator="{ on, attrs }">
                <img @click="logout" src="/img/navicon/SignOut.svg" alt="Logout" class="nav-img-icon logout-icon"
                  v-bind="attrs" v-on="on" style="cursor:pointer;" />
              </template>
              <span>Logout</span>
            </v-tooltip>
          </div>
          <!-- <div class="d-flex align-center justify-center">
              <v-divider vertical class="px-3" ></v-divider>
              <v-btn icon class="px-5 pl-10" >
                <v-icon style="font-size:20px !important; margin-top:-4px ">mdi-help-circle-outline</v-icon>
              </v-btn>
          </div> -->
          <!-- Profile menu moved into SideNav below Subscriptions -->
        </div>

      </v-app-bar>
      <div class="d-flex container-scroll shadow-off app-bar-bg">
        <SideNav :selectedItem.sync="selectedItem" :openMenu.sync="openMenu" :mini="navminivarient" :applist="applist"
          :clientload="clientload" :fdSupportWidget="fdSupportWidget" :chatbotEnabled="chatbotEnabled"
          :show-manuals="showManuals" @logout="logout" @manuals-click="openManuals"
          @edit-profile="editProfileDrawer = true; editProfileSetting = false" />
        <div class="snackbar-container d-flex flex-column">
          <v-snackbar bottom dense left
            v-for="(sanckbar, index) in $store.state.snackMultValue.filter((s) => s.showing)"
            :key="index + Math.random()" v-model="sanckbar.showing" class="csnackbars pa-0 snackbar" min-height="0"
            min-width="0" elevation="0" :timeout="sanckbar.time">
            <div class="shadow-on">
              <v-alert border="left" dark :type="sanckbar.type" text class="ma-0 white px-3" dense>
                <div class="d-flex">
                  <div class="d-flex flex-column justify-center">
                    <span class="body-2 textCapFirst">{{ sanckbar.text }}</span>
                  </div>
                  <v-btn icon class="ml-2" :color="sanckbar.type">
                    <v-icon @click="sanckbar.showing = false">mdi-close-circle</v-icon>
                  </v-btn>
                </div>
              </v-alert>
            </div>
          </v-snackbar>
        </div>
        <v-main v-resize="onResize" class="border-radius-main main-layout-main">
          <div class="nav-toggle-floating">
            <v-tooltip right content-class="tooltip-right">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="nav-toggle-btn" @click="toggleNavMini" v-bind="attrs" v-on="on">
                  <img src="/img/navicon/ChevronLeft.svg" alt="toggle navigation" class="nav-toggle-icon"
                    :class="{ 'nav-collapsed': navminivarient }" />
                </v-btn>
              </template>
              <span>{{ navminivarient ? 'Expand' : 'Collapse' }}</span>
            </v-tooltip>
          </div>
          <div class="all-height border-radius-main" style=" background-color: #fafafa">
            <div v-if="loading > 0" class="d-flex all-height align-center justify-center">
              <loader />
            </div>
            <div v-else class="main-content-holder">
              <div class="scroller" id="main-route-container">
                <div class="d-flex flex-column all-height">
                  <div class="flex-grow-1  all-height">
                    <!-- Regular page content -->
                    <v-fade-transition>
                      <router-view v-show="!floatingComponentOpen" :key="$route.fullPath"
                        class="position-absolute all-width all-height overflow-scroll"></router-view>
                    </v-fade-transition>
                    <!-- Floating Component Full Page View -->
                    <v-fade-transition>
                      <div v-if="floatingComponentOpen"
                        class="floating-component-page position-absolute all-width all-height"
                        :data-testid="`base__${floatingComponentOpen}-page`">
                        <div class="floating-component-content">
                          <chat-bot v-if="floatingComponentOpen === 'chatbot'" />
                          <!-- Future components can be added here -->
                        </div>
                      </div>
                    </v-fade-transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-main>
      </div>

      <lb-dialog v-model="EditDetails" heading="My Profile" width="600" persistent>
        <template v-slot:body>

          <div class="d-flex align-center mr-2 mb-3 justify-center">
            <div class="profile-wrapper">
              <v-avatar size="75" class="profile-avatar border-on">
                <v-img v-if="profileImage" :src="profileImage" />
                <v-icon v-else class="placeholder-icon">mdi-account</v-icon>
              </v-avatar>
              <v-btn icon class="upload-icon" @click="triggerFileInput">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>
            <input ref="fileInput" type="file" accept="image/*" @change="onImageUpload" class="d-none" />
          </div>

          <v-row>
            <v-col cols="12">
              <v-text-field v-model="userName" label="Name" prepend-icon="mdi-account" required></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="userEmail" readonly label="Email" prepend-icon="mdi-account"
                required></v-text-field>
            </v-col>
            <v-col cols="2" sm="12" class="py-0 d-flex align-center">
              <v-icon class="pr-3">mdi-phone</v-icon>
              <vue-country-code class="" :defaultCountry="CountryCode" style="height: fit-content; border:none"
                @onSelect="getCoutryCode"></vue-country-code>
              <v-text-field v-model="userContact" label="Contact" type="text" required
                @keydown="restrictInput"></v-text-field>
            </v-col>

            <v-col>
              <div style="height:10vh"></div>
            </v-col>
          </v-row>
          <v-col cols="1" sm="12" class="d-flex align-center justify-center">
            <v-spacer></v-spacer>
            <v-btn color="primary" class=" white--text" type="submit"
              @click="updateProfile()"><span>Update</span></v-btn>
            <v-spacer></v-spacer>
          </v-col>
        </template>
      </lb-dialog>

      <lb-drawer v-model="editProfileDrawer" heading="Profile Setting" width="800">
        <template v-slot:body>
          <div class="all-width">
            <div class="d-flex align-center justify-space-between all-width">
              <div class="d-flex align-center justify-start all-width">

                <div class="d-flex align-center mr-2 mb-3 justify-center">
                  <div class="profile-wrapper">
                    <v-avatar size="75" class="profile-avatar">
                      <v-img v-if="profileImage" :src="profileImage" />
                      <v-icon v-else class="placeholder-icon">mdi-account</v-icon>
                    </v-avatar>
                    <v-btn icon class="upload-icon" @click="triggerFileInput">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </div>
                  <input ref="fileInput" type="file" accept="image/*" @change="onImageUpload" class="d-none" />
                </div>


                <div class="d-flex flex-column align-start px-6 justify-start">
                  <p class="ma-0 pa-0 font-size-lg black--text font-weight-bold">{{ $store.state.user.name }}</p>
                  <p class="ma-0 pa-0 grey--text ">{{ $store.state.user.designation }}</p>
                </div>
              </div>
              <v-btn color="white"
                @click="editProfileSetting = true; editProfileDrawer = false"><v-icon>mdi-pencil-outline</v-icon><span>Edit
                  name</span></v-btn>
            </div>
            <v-divider></v-divider>
            <div class="mt-6">

              <v-row class="align-center">
                <v-col cols="3">
                  <p class="pa-0 ma-0">Status</p>
                </v-col>
                <v-col cols="5">
                  <v-menu :close-on-content-click="false" offset-y class="radius-small pa-0"
                    transition="slide-y-transition" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item class="profile pa-0 ma-0 " v-bind="attrs" v-on="on">
                        <div class="border-on d-flex align-center justify-space-between  pa-1 px-2 radius-medium ">
                          <v-icon :color="userStatus.color">{{ userStatus.icon || 'mdi-history' }}</v-icon>
                          <p class="pa-0 ma-0 px-2" :class="`${userStatus.color}--text`">{{ userStatus.name || 'Status'
                            }}</p>
                          <v-icon :color="userStatus.color">mdi-chevron-down</v-icon>
                        </div>
                      </v-list-item>
                    </template>

                    <v-list v-if="!addNewStatus"
                      class="pa-0 ma-0 d-flex flex-column align-start justify-start all-width"
                      style="max-height:100vh; overflow:hidden; width:30vh">
                      <v-list-title class="tableHeaderBg pa-2 all-width">Status</v-list-title>

                      <v-list class="d-flex all-width flex-column align-start px-1"
                        style="max-height:45vh; overflow:scroll">
                        <div class="d-flex align-center py-2 cursor-pointer  radius-small all-width"
                          :class="userStatus.name === item.name ? 'selected-item' : ''"
                          v-for="(item, index) in userStatuslist" :key="index"
                          @click="updateStatus(item.icon, item.name, item.color)">
                          <v-icon class="px-2" :color="userStatus.name === item.name ? 'white' : 'default'">
                            {{ item.icon }}
                          </v-icon>
                          {{ item.name }}
                        </div>
                      </v-list>
                      <v-divider></v-divider>
                      <v-list class="d-flex align-center px-1 all-width justify-space-between">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="addNewStatus = true; newstatusname = ''"
                          class="white--text px-1 font-size-xm"><span>Add new status</span></v-btn>
                      </v-list>

                    </v-list>

                    <v-list v-else class="pa-0 ma-0  d-flex flex-column align-start justify-start all-width">
                      <v-list-title class="d-flex align-center tableHeaderBg justify-start all-width">
                        <v-btn icon @click="addNewStatus = false">
                          <v-icon>mdi-keyboard-backspace</v-icon>
                        </v-btn>
                        <p class="pa-0 ma-0">Create new status</p>
                      </v-list-title>
                      <v-divider></v-divider>
                      <v-list-item class="my-2">
                        <p class="pa-1 ma-0  border-on radius-small mr-2">
                          <v-icon size="30" style="font-size:2.2rem !important">mdi-emoticon-happy-outline</v-icon>
                        </p>
                        <lb-string v-model="newstatusname" label="" :hidedetails="true"
                          placeholder="Enter new status"></lb-string>
                      </v-list-item>
                      <v-list-item class="d-flex align-center all-width justify-space-between">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click.stop="addNewStatustolist"
                          class="white--text px-1 font-size-xm"><span>Add
                            status</span></v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>


              <v-row>

                <v-col cols="3">
                  <p class="pa-0 ma-0">Email ID</p>
                </v-col>
                <v-col cols="5">
                  <p class="pa-0 ma-0">{{ $store.state.user.email }}</p>

                </v-col>
              </v-row>

              <v-row>

                <v-col cols="3">
                  <p class="pa-0 ma-0">Mobile number</p>
                </v-col>
                <v-col cols="5">
                  <p class="pa-0 ma-0">{{ $store.state.user.contactno }}</p>
                </v-col>
                <v-col cols="4" class="pa-1 d-flex justify-end align-center">
                  <v-btn color="white" class="font-size-xm"
                    @click="editProfileSetting = true; editProfileDrawer = false"><v-icon>mdi-pencil-outline</v-icon><span>Edit
                      number</span></v-btn>
                </v-col>
              </v-row>

            </div>
          </div>
        </template>
        <template v-slot:actions>
          <div class="d-flex align-center justify-end all-width">
            <v-btn class="secondaryBtn radius-small mx-2"><span>Request to change email</span></v-btn>
            <v-btn color="primary" @click="logout" link><span>Logout</span></v-btn>
          </div>
        </template>
      </lb-drawer>

      <lb-drawer v-model="editProfileSetting" heading="Profile Setting" width="800">
        <template v-slot:body>
          <div class="all-width">
            <div class="d-flex align-center justify-space-between all-width">
              <div class="d-flex align-center justify-start all-width">

                <div class="d-flex align-center mr-2 mb-3 justify-center">
                  <div class="profile-wrapper">
                    <v-avatar size="75" class="profile-avatar">
                      <v-img v-if="profileImage" :src="profileImage" />
                      <v-icon v-else class="placeholder-icon">mdi-account</v-icon>
                    </v-avatar>

                  </div>
                </div>
                <div class="d-flex flex-column align-start px-4 justify-start">
                  <lb-string label="" hidedetails :clearable="false" placeholder="Name" v-model="userName" />
                  <lb-string label="" class="my-2" placeholder="Designation" hidedetails :clearable="false"
                    v-model="userDesgination" />
                </div>
              </div>
              <v-btn color="caccounting" class="white--text" @click="updateProfile()"><span>Done</span></v-btn>
            </div>
            <v-divider></v-divider>
            <div class="mt-6">

              <v-row class="align-center">
                <v-col cols="3">
                  <p class="pa-0 ma-0">Status</p>
                </v-col>
                <v-col cols="5">
                  <v-menu :close-on-content-click="false" offset-y class="radius-small pa-0"
                    transition="slide-y-transition" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item class="pa-0 ma-0 " v-bind="attrs" v-on="on">
                        <div class="border-on d-flex align-center justify-space-between  pa-1 px-2 radius-medium ">
                          <v-icon :color="userStatus.color">{{ userStatus.icon || 'mdi-history' }}</v-icon>
                          <p class="pa-0 ma-0 px-2" :class="`${userStatus.color}--text`">{{ userStatus.name || 'Status'
                            }}</p>
                          <v-icon :color="userStatus.color">mdi-chevron-down</v-icon>
                        </div>
                      </v-list-item>
                    </template>

                    <v-list v-if="!addNewStatus"
                      class="profile pa-0 ma-0 d-flex flex-column align-start justify-start all-width"
                      style="max-height:50vh; overflow:hidden; width:30vh">
                      <v-list-title class="tableHeaderBg pa-2 all-width">Status</v-list-title>

                      <v-list-item class="d-flex all-width flex-column align-start px-1"
                        style="max-height:45vh; overflow:scroll">
                        <div class="d-flex align-center justify-start py-2 cursor-pointer  radius-small all-width"
                          v-for="(item, index) in userStatuslist" :key="index"
                          @click="updateStatus(item.icon, item.name, item.color)"
                          :class="userStatus.name === item.name ? 'selected-item' : ''">
                          <v-icon class="px-2" :color="userStatus.name === item.name ? 'white' : 'default'">
                            {{ item.icon }}
                          </v-icon>
                          {{ item.name }}
                        </div>
                      </v-list-item>
                      <v-divider></v-divider>
                      <v-list-item class="d-flex align-center all-width justify-space-between">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="addNewStatus = true; newstatusname = ''"
                          class="white--text px-1 font-size-xm"><span>Add new status</span></v-btn>
                      </v-list-item>

                    </v-list>

                    <v-list v-else class="pa-0 ma-0  d-flex flex-column align-start justify-start all-width">
                      <v-list-title class="d-flex align-center tableHeaderBg justify-start all-width">
                        <v-btn icon @click="addNewStatus = false">
                          <v-icon>mdi-keyboard-backspace</v-icon>
                        </v-btn>
                        <p class="pa-0 ma-0">Create new status</p>
                      </v-list-title>
                      <v-divider></v-divider>
                      <v-list-item class="my-2">
                        <p class="pa-1 ma-0  border-on radius-small mr-2">
                          <v-icon size="30" style="font-size:2.2rem !important">mdi-emoticon-happy-outline</v-icon>
                        </p>
                        <lb-string v-model="newstatusname" label="" :hidedetails="true"
                          placeholder="Enter new status"></lb-string>
                      </v-list-item>
                      <v-list-item class="d-flex align-center all-width justify-space-between">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click.stop="addNewStatustolist"
                          class="white--text px-1 font-size-xm"><span>Add
                            status</span></v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3">
                  <p class="pa-0 ma-0">Email ID</p>
                </v-col>
                <v-col cols="5">
                  <p class="pa-0 ma-0">{{ $store.state.user.email }}</p>

                </v-col>
              </v-row>
              <v-row class="align-center justify-start d-flex">
                <v-col cols="3">
                  <p class="pa-0 ma-0">Mobile number</p>
                </v-col>
                <v-col cols="5">
                  <lb-string label="" :hidedetails=true :clearable="false" v-model="userContact"></lb-string>
                </v-col>
                <v-col cols="4" class="pa-1 d-flex justify-end align-center">
                  <v-btn color="caccounting" class="white--text" @click="updateProfile()"><span>Done</span></v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </template>
        <template v-slot:actions>
          <div class="d-flex align-center justify-end all-width">
            <v-btn class="secondaryBtn radius-small mx-2"><span>Request to change email</span></v-btn>
            <v-btn color="primary" @click="logout" link><span>Logout</span></v-btn>
          </div>
        </template>
      </lb-drawer>
    </v-layout>
  </v-app>
</template>

<script>
import loader from './common/Loader';
import SideNav from '@/components/SideNav.vue';
import ChatBot from '@/modules/chatbot/views/ChatBot.vue';
const { default: constants } = require('../plugins/constants');
const { FC_ROUTES, FC_UNDEFINED_ID_PATTERN } = require('../modules/financialclose/utils/constants');

export default {
  name: "app",
  data: () => ({
    group: null,
    login: false,
    showNavgation: true,
    navminivarient: true, // Always collapsed (mini) by default
    showHeaderAction: true,
    containerHeight: 0,
    clientload: false,
    downloaddialog: false,
    activemenu: 0,
    reloadkey: 0,
    display: "load",
    loading: 0,
    routeid: "",
    applist: [
    ],
    appname: "",
    selectedclient: "",
    pathName: "",
    isPlanExpaired: false,
    newMenuList: [],
    admins: [
      ['Management', 'mdi-account-multiple-outline'],
      ['Settings', 'mdi-cog-outline'],
    ],
    editProfileDrawer: false,
    userStatuslist: [
      {
        icon: "mdi-check-circle",
        name: "Available",
        color: 'success'
      },
      {
        icon: "mdi-calendar-blank",
        name: " In a meeting",
        color: 'info'
      },
      {
        icon: "mdi-minus-circle-outline",
        name: "Do not disturb",
        color: 'error'
      },
      {
        icon: "mdi-close-circle-outline",
        name: "Appear Away",
        color: 'primary'
      },
    ],
    userStatus: {},
    newstatusname: "",
    addNewStatus: false,
    profileImage: null,
    profileImageError: false,
    profileImageMenuError: false,
    editProfileSetting: false,
    userName: "",
    userContact: "",
    userDesgination: "",
    EditDetails: false,
    userEmail: '',
    CountryCode: '',
    selectedItem: null,
    openMenu: false,
    timerId: null,
    logoImageError: false,
    fdSupportWidget: process.env?.VUE_APP_FD_SUPPORT_WIDGET === "true" || process.env?.VUE_APP_FD_SUPPORT_WIDGET === true,
    chatWidgetInView: false,
    floatingComponentOpen: null, // null | 'chatbot' | future component names
  }),
  components: {
    loader,
    SideNav,
    ChatBot,
  },
  created() {
    // this.$store.dispatch('fetchCycleList');
    // Always collapsed (mini) by default, do not override from localStorage or store
    // Force mini/collapsed by default, do not read from localStorage or store
    this.navminivarient = true;
    this.profileImage = this.$store.state.user.profile || null
    this.userName = this.$store.state.user.name || ""
    this.userContact = this.$store.state.user.contactno || ""
    this.userDesgination = this.$store.state.user.designation || ""
    this.userEmail = this.$store.state.user.email
    const existingStatus = this.userStatuslist.find(
      status => status.name === this.$store.state.user.activestatus
    );
    if (existingStatus) {
      this.userStatus = { icon: existingStatus.icon, name: existingStatus.name, color: existingStatus.color };
    } else {
      let newstatus = {
        icon: "mdi-emoticon-happy-outline",
        name: this.$store.state.user.activestatus,
        color: 'caccounting'
      };
      this.userStatuslist.push(newstatus);
      this.userStatus = { icon: newstatus.icon, name: newstatus.name, color: newstatus.color };
    }

    // this.setMenu(this.$route.path);
    this.getLocationHeader();
    this.getDetails();
  },
  mounted() {
    // Attach openFDSupport to root instance for child components
    this.$root.openFDSupport = this.openFDSupport;
    // Attach floating component methods to root instance for child components
    this.$root.openFloatingComponent = this.openFloatingComponent;
    this.$root.toggleChatbot = this.toggleChatbot;
    this.$root.closeChatbot = this.closeChatbot;
    this.$root.closeFloatingComponent = this.closeFloatingComponent;
    this.$root.closeFloatingComponents = this.closeFloatingComponents;

    this.selectedclient = this.$route.query.cid || "";
    this.dragFunctions();
    this.onResize();
    this.fetchLabelsData();
    document.body.classList.toggle('nav-mini', this.navminivarient);
    document.body.classList.toggle('nav-full', !this.navminivarient);
    // ----------------
    // TODO - use this in the future if authentication is needed for Freshdesk widget
    // To enable authenticated widget experience, generate a JWT and call:
    // this.$freshworks.authenticate(token);
    // See: https://developers.freshdesk.com/widget-api/
    // ----------------
  },
  beforeUnmount() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  methods: {
    toggleNavMini() {
      // Toggle the nav state AND persist to store so watchers & other components stay in sync
      this.navminivarient = !this.navminivarient;
      this.$store.commit('toogleNavBar', this.navminivarient);
    },
    onImageUpload(event) {
      const file = event.target.files[0];
      this.updateProfile(file)
      if (file) {
        this.profileImage = URL.createObjectURL(file);
      }
    },
    restrictInput(event) {
      const key = event.key;
      if (!/^[0-9]$/.test(key) && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(key)) {
        event.preventDefault();
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    getCoutryCode({ iso2 }) {
      this.userDetails.countrycode = iso2
    },
    updateStatus(icon, name, color) {
      this.userStatus = { icon, name, color };
      this.updateProfile()
    },
    addNewStatustolist() {
      let newstatus = {
        icon: "mdi-emoticon-happy-outline",
        name: this.newstatusname,
        color: 'caccounting'
      };
      if (!this.userStatuslist.includes(newstatus)) {
        this.userStatuslist.push(newstatus);
      }
      this.updateStatus(newstatus.icon, newstatus.name);
      this.addNewStatus = false
    },
    changeNavVarient(flag) {
      this.$store.commit('toogleNavBar', flag);
    },
    getDetails() {
      if (!this.$store.state.noauth) {
        this.$store.commit("addLoading");
        this.loading++;
        let pcodes = [];
        let rdata = {};
        const { PRODUCT_KEYS, PLAN_FREE, ROUTE_PATHS, API_URLS, STORAGE_KEYS, STORE_MODULE_PREFIX, APP_REGISTRY } = constants;
        this.axios.post(API_URLS.PROFILE_GET_DETAILS).then(dt => {

          if (dt.data.status === "success") {
            rdata = (dt.data.data || [])[0] || {};
            let clientdata = rdata.clients || [];
            this.$store.commit("setClientList", clientdata);
            this.$store.commit("refreshClient", false);
            if (clientdata.length > 0) {
              let clientinurl = "";
              if (this.$route.query.cid) {
                for (const i of clientdata) {
                  if (i._id === this.$route.query.cid) clientinurl = i._id;
                }
              }
              if (clientinurl) {
                if (clientinurl !== this.selectedclient) this.selectedclient = clientinurl;
              }
              else this.selectedclient = clientdata[0]._id;
              localStorage.setItem(STORAGE_KEYS.ENTITY, this.selectedclient)
            }
            let subsdata = rdata.subscription || {};
            // Check for Free plan expiry on products that support it
            const expiryProducts = [PRODUCT_KEYS.FINANCIAL_CLOSE, PRODUCT_KEYS.VARIANCE_ANALYSIS];
            for (const productSub in subsdata) {
              if (expiryProducts.includes(productSub)) {
                const data = subsdata[productSub];
                if (data.plan_detail.name === PLAN_FREE) {
                  this.isPlanExpaired = data.plan_detail.expiry || false;
                  if (this.isPlanExpaired) {
                    const storeKey = STORE_MODULE_PREFIX + productSub;
                    if (this.$store.state[storeKey]) {
                      this.$store.state[storeKey].menu = [];
                    }
                  }
                }
              }
            }
            if (Object.keys(subsdata).length <= 2) {
              let redirectlink = "";
              let redirectflag = true;
              let redirectIsFC = false;
              for (const k in subsdata) {
                if (Object.hasOwnProperty.call(subsdata, k)) {
                  if (k !== PRODUCT_KEYS.ADMIN) {
                    const el = subsdata[k];
                    if (redirectlink === "") {
                      redirectlink = el?.product_detail?.homepage || "";
                      redirectIsFC = (k === PRODUCT_KEYS.FINANCIAL_CLOSE);
                    }
                    else redirectflag = false
                  }
                }
              }
              if (redirectflag) {
                if (redirectIsFC) {
                  // console.log("Redirecting to FC landing page due to only having access to FC with free plan");
                  this.navigateToFCLanding();
                } else {
                  this.$nova.gotoLink({ path: redirectlink });
                }
              }
            }
            this.$store.commit("setSubscription", subsdata);

            for (const k in subsdata) {
              if (Object.hasOwnProperty.call(subsdata, k)) {
                const el = subsdata[k];
                pcodes.push(el.product_detail.code);
              }
            }
            return this.axios.post(API_URLS.AUTH_GET_PERMISSION, {});
          } else {
            this.$store.commit("sbError", "Error fetching client list");
          }
        }).then(dt => {
          if (dt.data.status === "success") {
            if (dt.data.data.length > 0) {
              this.$store.commit("setPermission", dt.data.data[0]);
              const perm = dt.data.data[0];
              this.applist = [];
              for (const entry of APP_REGISTRY) {
                // Check if any of the entry's product codes are in the subscribed list
                const hasCode = entry.codes.some(code => pcodes.includes(code));
                if (!hasCode) continue;
                // Check permission if required
                if (entry.permissionKey) {
                  // For TDS: permission only required for specific codes (tds_monthly)
                  if (entry.permissionOnlyCodes) {
                    const needsPermCheck = entry.permissionOnlyCodes.some(c => pcodes.includes(c));
                    const otherCodesPresent = entry.codes.filter(c => !entry.permissionOnlyCodes.includes(c)).some(c => pcodes.includes(c));
                    if (!otherCodesPresent && needsPermCheck && !perm[entry.permissionKey]) continue;
                  } else {
                    if (!perm[entry.permissionKey]) continue;
                  }
                }
                const displayname = entry.useBotName ? constants.BOT_NAME + 's' : entry.displayname;
                this.applist.push({ name: entry.name, displayname, color: entry.color, avatartext: entry.avatartext, logo: "", icon: "", link: entry.link });
              }
            }
          } else throw Error("Error fetching permission details");
        }).then(() => {
          console.log("six month");
          this.scheduleLabelsApiCall();
        }).catch(err => {
          this.$store.commit("sbError", err.message || "Unknown error!");
          console.log(err);
        }).finally(async () => {
          this.onResize();
          this.clientload = true;
          this.reloadkey += 1;
          await this.checkSubscriptionPermission(this.$route, this.$route);
          this.$store.commit("removeLoading");
          // Handle redirects BEFORE decrementing loading so the loader
          // stays visible while FC cycle data is being fetched.
          if (this.$route.path === ROUTE_PATHS.ROOT) {
            if (this.applist.find((item) => item.name === PRODUCT_KEYS.FINANCIAL_CLOSE)) {
              console.log("Redirecting to FC landing page as it's the only product available");
              const cycle = await this.fetchFCLandingCycle();
              this.navigateToFCRoute(cycle);
            } else if (this.applist.find((item) => item.name === PRODUCT_KEYS.VARIANCE_ANALYSIS)) {
              this.$nova.gotoLink({ path: ROUTE_PATHS.VA_ACTUAL_ANALYSIS });
            } else {
              this.$nova.gotoLink({ path: this.applist?.[0]?.link });
            }
          }
          // Handle undefined project ID in current route
          await this.handleUndefinedProjectId();
          this.loading--;
        });
      } else {
        this.reloadkey += 1;
        this.clientload = true;
      }
    },
    async fetchLabelsData() {
      localStorage.setItem(constants.STORAGE_KEYS.LABELS_LIST, "");
      localStorage.setItem(constants.STORAGE_KEYS.LAST_LOGIN_TIME, "");
      try {
        const response = await this.axios.post(constants.API_URLS.COMMENTARY_GET_PAGES);
        if (response?.data?.status === "success") {
          const labelsList = response.data.data;
          localStorage.setItem(constants.STORAGE_KEYS.LABELS_LIST, JSON.stringify(labelsList));
          localStorage.setItem(constants.STORAGE_KEYS.LAST_LOGIN_TIME, Date.now().toString());

          const formattedLabels = this.transformData(labelsList);
          this.$store.commit('addlabels', formattedLabels);
        } else {
          console.error("API Error:", response?.data?.message || "Unknown error");
        }
      } catch (error) {
        console.error("Request failed:", error);
      }
    },

    transformData(input) {
      if (!input || typeof input !== "object") return {};

      const output = {};
      for (const page in input) {
        if (!Array.isArray(input[page])) continue;

        output[page] = {};
        input[page].forEach(({
          label_id,
          value,
          default: defaultValue
        }) => {
          if (!label_id) return;
          const normalizedKey = label_id.trim().replace(/\s+/g, "_").replace(/lebel/g, "label");
          output[page][normalizedKey] = {
            value,
            default: defaultValue
          };
        });
      }
      return output;
    },

    scheduleLabelsApiCall() {
      const storedTimestamp = localStorage.getItem(constants.STORAGE_KEYS.LAST_LOGIN_TIME);
      const lastLoginTime = storedTimestamp ? parseInt(storedTimestamp, 10) : 0;
      const currentTime = Date.now();
      const timeElapsed = currentTime - lastLoginTime;
      const oneDayMs = 24 * 60 * 60 * 1000;

      if (!lastLoginTime || isNaN(lastLoginTime) || timeElapsed >= oneDayMs) {
        this.fetchLabelsData();
      } else {
        const timeRemaining = oneDayMs - timeElapsed;
        this.timerId = setTimeout(() => this.fetchLabelsData(), timeRemaining);
      }
    },

    logout() {
      this.axios.post(constants.API_URLS.AUTH_LOGOUT, {
      }).then(x => {
        if (x.data.status == "success") {
          this.$store.commit("changeLogin", false);
          this.$store.commit("setUser", null);
          this.$router.push('/');
          this.fetchLabelsData();
        }
      }).catch(e => {
        this.$store.commit("sbError", e.message || "Logout error!");
        console.log(e);

      })
    },
    menuSourcePath(path) {
      if (!constants.isManualsPath(path || '')) return path;
      const product = constants.resolveManualsProduct(
        `/${this.$route.query[constants.MANUALS_PRODUCT_QUERY] || ''}`,
      );
      return product ? `/${product}` : path;
    },
    setMenu(path) {
      const menuPath = this.menuSourcePath(path);
      this.appname = constants.STORE_MODULE_PREFIX + (menuPath || "").split("/")[1] || "";
      // console.log( this.appname,"FFF");
      let menuitems = [];
      let storeobj = this.$store.state[this.appname] || {};
      if (storeobj.menu) {
        if (this.$store.state.newmenu.length > 0) menuitems = [...this.$store.state.newmenu, ...this.$store.state.custommenu];
        else menuitems = [...this.$store.state[this.appname]?.menu, ...this.$store.state.custommenu];
      }
      else menuitems = [];
      let newmenu = [];
      let dummymenu = [];
      let headerstart = false;
      let menupostsubs = [];
      let addcust = this.$route.meta?.submenu || [];
      let params = this.$route.params;
      // console.log(this.$route);
      for (const i of menuitems) {
        if (i.submenu && addcust.indexOf(i.variable) > -1) {
          if (storeobj[i.variable]) {
            let nm = [];
            // console.log("in1111")
            for (const j of storeobj[i.variable]) {
              if (j.href) {
                let nj = { ...j };
                // console.log("in1122", nj.href);
                let replacetexts = nj.href.match(/\${2}\w+[^_]\${2}/g) || [];
                for (const k of replacetexts) {
                  let ttext = k.replaceAll("$", "");
                  // console.log("in2222", k, params[ttext]);
                  if (params[ttext]) nj.href = nj.href.replaceAll(k, params[ttext]);
                  // console.log("post replace", nj.href);
                }
                nm.push(nj)
              } else nm.push(j);
            }
            menupostsubs = [...menupostsubs, ...nm]
          }
        } else menupostsubs.push(i);
      }
      for (const i of menupostsubs) {
        if (i.product) newmenu.push(i);
        else if (i.header) {
          if (headerstart) {
            if (dummymenu.length > 1) newmenu = [...newmenu, ...dummymenu];
            dummymenu = [];
          }
          dummymenu.push(i);
          headerstart = true;
        } else {
          if ((i.href === constants.ROUTE_PATHS.VA_QUEUE || i.label_id === 'commentary_queue_management_label_menu') && !this.$store.getters.isQueueEnabled) {
            continue;
          }
          // Skip items hidden for super admin (check actual permission, not store flag)
          if (i.hideForSuperAdmin && this.$nova.hasRight('commentary', ['superadmin'])) {
            continue;
          }
          if (this.$nova.hasRight(i.right, i.action)) {
            if (headerstart) dummymenu.push(i);
            else newmenu.push(i);
          }
        }
      }
      if (dummymenu.length > 1) newmenu = [...newmenu, ...dummymenu];
      newmenu.map((menuitem) => {
        if (menuitem.label_id) {
          menuitem.title = this.$nova.labelsName('cycle_page', menuitem.label_id, menuitem.title)
        }
        return menuitem;
      })
      this.$store.commit("setMenu", newmenu);
    },
    setCustomMenu() {
    },
    onResize() {
      setTimeout(() => {
        // Previously we forcibly collapsed the nav (mini) on < lg breakpoints.
        // That prevented users from expanding it at widths like 1024px (md/lg boundary on some devices).
        // We now allow manual expansion even on smaller screens. If you want an auto-collapse ONLY when
        // entering really (e.g., xs) widths, implement a conditional here (e.g., if (this.$vuetify.breakpoint.xs)).
      }, 500);
      if (this.$refs.toolbar && document.getElementById("main")) {
        this.$store.commit("setHeight", (((document.getElementById("main").offsetHeight) - (this.$refs.toolbar.$el.offsetHeight || 0) - 2) || '100vh'));
      }
    },
    getExtImage: function (n) {
      let na = n.split(".");
      let ext = na[na.length - 1];
      if (ext === "pptx") return "/img/tpa_icons/ppt.jpg";
      else if (ext === "xlsx") return "/img/tpa_icons/excel.jpg";
      else if (ext === "zip") return "/img/tpa_icons/zip.jpg";
      else return "";
    },
    dragFunctions() {
      document.addEventListener('dragstart', event => {
        event.target.style.opacity = 0.5;
      });
      document.addEventListener('dragend', event => {
        event.target.style.opacity = 1;
      });
    },
    // ─── Financial Close helpers ────────────────────────────────────
    // All FC-specific navigation, route-param handling, cycle info
    // fetching, and client-switch logic lives in this section.
    // Other FC-aware code (getDetails, checkSubscriptionPermission)
    // stays inline because those methods handle multiple products.
    // ─────────────────────────────────────────────────────────────────

    /**
     * Fetch the most recent open cycle for the current client.
     * Returns the cycle object if found, or null.
     */
    async fetchFCLandingCycle() {
      try {
        const cycle = await this.$store.dispatch('project/fetchMostRecentOpenCycle');
        console.log('[base.vue]: fetchFCLandingCycle response', cycle);
        return (cycle && cycle._id) ? cycle : null;
      } catch (err) {
        console.error('[base.vue]: fetchFCLandingCycle error', err);
        return null;
      }
    },
    /**
     * Navigate to a FC cycle's checklist, or fall back to /financialclose/home.
     * Pure navigation — no async work.
     */
    navigateToFCRoute(cycle) {
      const cid = this.$store.state.client;
      if (cycle && cycle._id) {
        this.$store.commit('addItemToCycleList', cycle);
        this.$nova.gotoLink({ path: FC_ROUTES.CHECKLIST(cycle._id), query: { cid } });
      } else {
        this.$nova.gotoLink({ path: FC_ROUTES.HOME, query: { cid } });
      }
    },
    /**
     * Convenience: fetch cycle + navigate in one call.
     */
    async navigateToFCLanding() {
      const cycle = await this.fetchFCLandingCycle();
      this.navigateToFCRoute(cycle);
    },
    /**
     * Detect and handle routes with 'undefined' as the project ID.
     */
    async handleUndefinedProjectId() {
      const path = this.$route.path || '';
      if (!path.includes(constants.PRODUCT_KEYS.FINANCIAL_CLOSE)) return;
      if (!FC_UNDEFINED_ID_PATTERN.test(path)) return;
      console.log(`[base.vue]: Detected route with undefined project ID: ${path}, redirecting to FC landing`);
      await this.navigateToFCLanding();
    },
    /**
     * Called by the $route.params.id and $route.params.projectId watchers.
     * Validates the cycle ID and fetches cycle info, or redirects to FC
     * landing when the ID is missing/undefined.
     */
    handleFCRouteParamChange(cycleId) {
      if (!this.$route.path.includes(FC_ROUTES.PROJECT_PREFIX)) return;
      if (!cycleId || cycleId === 'undefined') {
        console.log(`[base.vue]: Detected undefined project ID in route, redirecting to FC landing`);
        this.navigateToFCLanding();
        return;
      }
    },
    /**
     * Called by the selectedclient watcher when the client changes while
     * on an FC project page. The current project ID belongs to the old
     * client, so we navigate to the correct cycle for the new client
     * instead of pushing the stale URL (old project + new cid).
     * Returns true if the FC redirect was triggered (caller should skip
     * the normal syncClientInUrl).
     */
    async handleFCClientSwitch(newClient, previousClient) {
      if (!newClient || !previousClient) return false;
      if (!this.$route.path.includes(FC_ROUTES.PROJECT_PREFIX)) return false;
      console.log(`[base.vue]: Client changed from ${previousClient} to ${newClient} while on FC project page, navigating to FC landing`);
      await this.navigateToFCLanding();
      return true;
    },

    // ─── End Financial Close helpers ────────────────────────────────

    // ─── Client URL sync & Product Access ──────────────────────────────

    /**
     * Find the best available product route for a given client.
     * Checks hasFinancialCloseAccess and hasVarianceAnalysisAccess flags.
     * Returns null if no products available.
     */
    getBestProductRouteForClient(clientId) {
      const clientData = this.$store.state.clientlist?.find(c => c._id === clientId);
      if (!clientData) return null;

      // Prioritize FC, then VA, then the first available product from applist
      if (clientData.hasFinancialCloseAccess) {
        return clientData.financialCloseHomepage || constants.ROUTE_PATHS.ROOT;
      }
      if (clientData.hasVarianceAnalysisAccess) {
        return clientData.varianceAnalysisHomepage || constants.ROUTE_PATHS.VA_ACTUAL_ANALYSIS;
      }
      // Fallback to first product in applist (if any)
      return this.applist?.[0]?.link || constants.ROUTE_PATHS.ROOT;
    },

    /**
     * Check if the new client has access to the current route's product.
     * Returns true if access is granted, false if a redirect is needed.
     * If false, also performs the redirect.
     */
    async checkAndRedirectForClientProduct(newClientId) {
      const clientData = this.$store.state.clientlist?.find(c => c._id === newClientId);
      if (!clientData) return true; // Can't verify, allow navigation

      const currentPath = this.$route.path;

      // Check FC access
      if (currentPath.includes(`/${constants.PRODUCT_KEYS.FINANCIAL_CLOSE}/`)) {
        if (!clientData.hasFinancialCloseAccess) {
          const redirectPath = this.getBestProductRouteForClient(newClientId);
          if (redirectPath) {
            console.log(`[base.vue]: Client ${newClientId} lacks FC access, redirecting to ${redirectPath}`);
            this.$nova.gotoLink({ path: redirectPath, query: { cid: newClientId } });
          }
          return false;
        }
      }

      // Check VA access
      if (currentPath.includes(`/${constants.PRODUCT_KEYS.VARIANCE_ANALYSIS}/`)) {
        if (!clientData.hasVarianceAnalysisAccess) {
          const redirectPath = this.getBestProductRouteForClient(newClientId);
          if (redirectPath) {
            console.log(`[base.vue]: Client ${newClientId} lacks VA access, redirecting to ${redirectPath}`);
            this.$nova.gotoLink({ path: redirectPath, query: { cid: newClientId } });
          }
          return false;
        }
      }

      // For admin and other shared pages, verify they have SOME product access
      if (currentPath.includes(`/${constants.PRODUCT_KEYS.ADMIN}/`) ||
        currentPath.includes(`/${constants.PRODUCT_KEYS.PBC}/`) ||
        currentPath.includes(`/${constants.PRODUCT_KEYS.BOT}/`) ||
        currentPath.includes(`/${constants.PRODUCT_KEYS.HELPDESK}/`)) {
        const hasAnyAccess = clientData.hasFinancialCloseAccess || clientData.hasVarianceAnalysisAccess;
        if (!hasAnyAccess) {
          // No products available for this client
          console.warn(`[base.vue]: Client ${newClientId} has no product access`);
          this.$nova.gotoLink({ path: constants.ROUTE_PATHS.ROOT });
          return false;
        }
      }

      return true; // Access granted
    },

    /**
     * Push the current route with the given client cid in the query string.
     * No-op when the URL already has the correct cid.
     */
    syncClientInUrl(clientId) {
      const routeData = {
        path: this.$route.path,
        query: { ...this.$route.query },
        hash: this.$route.hash,
      };
      const oldpath = JSON.stringify(routeData);
      routeData.query.cid = clientId;
      const newpath = JSON.stringify(routeData);
      if (oldpath !== newpath) {
        this.$router.push(routeData).catch(() => { });
      }
    },

    /**
     * Verify user has subscription and permission to access a route.
     * Called on route navigation when cid remains the same.
     * NOTE: When cid changes, this DOES NOT run — preemptive checks
     * in selectedclient watcher handle client-switch redirects.
     */
    async checkSubscriptionPermission(to, from) {
      // Only check when navigating within the same client (cid unchanged)
      if (from.query.cid !== to.query.cid) return;

      const requiredsubs = to.meta.subscription || [];
      const avaliablesubs = this.$store.state.subscriptions;

      // Check subscription
      const hasSubscription = requiredsubs.length === 0 || requiredsubs.some(sub =>
        avaliablesubs[sub] || avaliablesubs[sub?.toUpperCase()]
      );

      // Check permission
      const hasPermission = !to.meta.right || this.$nova.hasRight(to.meta.right, to.meta.action);

      // Allow if: (has both sub & permission) OR route allows all OR subscriptions are disabled
      if ((hasSubscription && hasPermission) || to.meta.allow || process.env.VUE_APP_IGNORE_SUBSCRIPTIONS === '1') {
        this.setCustomMenu();
        this.setMenu(to.path);
        return;
      }

      // Access denied — redirect to an available product
      console.log(`[base.vue]: Access denied to ${to.path}, redirecting...`);

      // Build redirect route data
      const routeData = {
        path: to.path,
        query: { ...to.query },
        hash: to.hash,
      };

      // Determine redirect destination based on available products
      if (this.applist.find(item => item.name === constants.PRODUCT_KEYS.FINANCIAL_CLOSE)) {
        if (!hasSubscription) {
          // console.log("Redirecting to FC landing page due to missing subscription for current route");
          await this.navigateToFCLanding();
        } else {
          // Has subscription but lacks permission — go back
          this.$router.go(-1);
        }
      } else if (this.applist.find(item => item.name === constants.PRODUCT_KEYS.VARIANCE_ANALYSIS)) {
        routeData.path = constants.ROUTE_PATHS.VA_ACTUAL_ANALYSIS;
        this.$router.push(routeData).catch(() => { });
      } else {
        // Fallback to first available product
        routeData.path = this.applist?.[0]?.link || constants.ROUTE_PATHS.ROOT;
        this.$router.push(routeData).catch(() => { });
      }

      this.setCustomMenu();
      this.setMenu(to.path);
    },
    findIcon(name) {
      let iconname = this.$store.state.menu.filter((item) => {
        if (item.title === name)
          return item.icon
      })
      return iconname[0].icon
    },
    findlist() {
      const result = {};
      let currentKey = null;
      this.$store.state.menu.forEach(obj => {
        if (obj.header) {
          currentKey = obj.title;
          result[currentKey] = [];
        } else if (currentKey) {
          result[currentKey].push(obj);
        }
      });
      this.newMenuList = result;
    },

    async updateProfile(file = null) {
      const now = new Date();
      const epochTime = now.getTime();
      if (!this.$store.state.noauth) {
        let profilePath = '';
        let details = {
          username: this.userName || this.$store.state.user.name || "",
          contactno: this.userContact || this.$store.state.user.contact || "",
          countrycode: this.$store.state.user.countrycode || "",
          email: this.$store.state.user.email || "",
          designation: this.userDesgination || this.$store.state.user.designation || "",
          activestatus: this.userStatus.name || this.$store.state.user.activestatus || "",
        };
        if (file) {
          profilePath = await this.$nova.uploadFile(this.axios, file);
          details = {
            ...details,
            profile_url: profilePath.data.data[0].path,
            upload_id: profilePath.data.data[0]._id,
            profile_url_expiration: epochTime,
          }
        }

        this.axios.post(constants.API_URLS.PROFILE_UPDATE, { data: [details] }).then(dt => {
          if (dt.data.status == 'success') {
            this.$store.commit("sbSuccess", "Profile Updated successfully")
            this.$store.state.user = dt.data.data[0]
            this.$store.state.user.id = dt.data.data?.[0]?._id || ''
          }
          else {
            this.$store.commit("sbError", dt.data.message || "Unknown error!");
          }
          this.profileImage = dt.data.data[0].profile_url
          this.editProfileDrawer = false
          this.editProfileSetting = false
        });
      }
    },
    async getLocationHeader() {
      await this.$store.dispatch('fetchLocation');
    },
    openManuals() {
      const query = {};
      if (this.selectedclient) query.cid = this.selectedclient;
      if (this.manualsProduct) query[constants.MANUALS_PRODUCT_QUERY] = this.manualsProduct;
      this.$nova.gotoLink({
        path: constants.ROUTE_PATHS.MANUALS,
        query,
      });
    },
    openFDSupport() {
      this.selectedItem = 'support';

      // Use the Freshworks plugin for cleaner API
      if (!this.$freshworks?.isEnabled) {
        // console.log('[base.vue]: Freshworks widget is not enabled');
        return;
      }

      // Toggle widget state
      const isNowOpen = this.$freshworks.toggle({
        name: this.userName,
        email: this.userEmail
      });

      this.chatWidgetInView = isNowOpen;

      // Register close callback to sync state
      if (isNowOpen) {
        this.$freshworks.onClose(() => {
          this.chatWidgetInView = false;
        });
      }
    },

    openFloatingComponent(componentName) {
      // Generic method to open any floating component
      // Automatically closes other floating components
      if (this.floatingComponentOpen === componentName) {
        // Toggle off if clicking the same component
        this.floatingComponentOpen = null;
        this.selectedItem = null;
      } else {
        this.selectedItem = componentName;
        this.floatingComponentOpen = componentName;
      }
    },
    toggleChatbot() {
      this.openFloatingComponent('chatbot');
    },
    closeChatbot() {
      if (this.floatingComponentOpen === 'chatbot') {
        this.floatingComponentOpen = null;
        if (this.selectedItem === 'chatbot') {
          this.selectedItem = null;
        }
      }
    },
    closeFloatingComponent(componentName) {
      // Generic method to close a specific floating component
      if (this.floatingComponentOpen === componentName) {
        this.floatingComponentOpen = null;
        if (this.selectedItem === componentName) {
          this.selectedItem = null;
        }
      }
    },
    closeFloatingComponents(context) {
      // Centralized method to close all floating/overlay components
      // Skip closing if the context is the component being opened
      if (!context || context !== this.floatingComponentOpen) {
        this.floatingComponentOpen = null;
        if (this.selectedItem && this.selectedItem !== context) {
          this.selectedItem = null;
        }
      }
    },
  },
  computed: {
    chatbotEnabled() {
      return this.$store.state.chatbotEnabled;
    },
    manualsProduct() {
      const path = this.$route.path || '';
      if (constants.isManualsPath(path)) {
        const queryProduct = this.$route.query[constants.MANUALS_PRODUCT_QUERY] || '';
        return constants.resolveManualsProduct(`/${queryProduct}`);
      }
      return constants.resolveManualsProduct(path);
    },
    showManuals() {
      return constants.manualsAreAvailable(
        this.$store.state.m_manuals || {},
        this.manualsProduct,
        this.selectedclient,
      );
    },
    manualsAvailabilityKey() {
      return `${this.selectedclient || ''}:${this.manualsProduct || ''}`;
    },
  },
  watch: {
    // ─── FC route param watchers ──────────────────────────────────
    // These delegate to handleFCRouteParamChange in the FC helpers
    // section. They exist as watchers because Vue requires them here,
    // but the logic is consolidated in the methods above.
    '$route.params.id': {
      handler(newId) {
        const effectiveId = newId || this.$route.params.projectId;
        this.handleFCRouteParamChange(effectiveId);
      },
      immediate: true
    },
    '$route.params.projectId': {
      handler(newProjectId) {
        if (!newProjectId) return;
        this.handleFCRouteParamChange(newProjectId);
      },
    },
    // ─── End FC route param watchers ──────────────────────────────
    profileImage() {
      this.profileImageError = false;
      this.profileImageMenuError = false;
    },
    $route(to, from) {
      this.checkSubscriptionPermission(to, from);
    },
    manualsAvailabilityKey: {
      immediate: true,
      handler() {
        if (!this.$store.hasModule('m_manuals')) return;
        this.$store.dispatch('m_manuals/fetchAvailability', {
          product: this.manualsProduct,
          clientId: this.selectedclient,
        });
      },
    },
    selectedclient: async function (d) {
      const previousClient = this.$store.state.client;
      // Store-initiated sync: client already matches, just ensure cid is in URL.
      if (d === previousClient) {
        this.syncClientInUrl(d);
        return;
      }
      try {
        if (d) {
          this.$store.commit('resetCycles');
        }
        this.$store.commit("setClient", d);

        // Check product access for the new client BEFORE navigating.
        // For FC project pages, use the specialized handler.
        if (this.$route.path.includes(FC_ROUTES.PROJECT_PREFIX)) {
          if (await this.handleFCClientSwitch(d, previousClient)) return;
        }

        // For all other routes, check if client has access to current product.
        // If not, redirect to an available product (prevents intermediate URL).
        const hasAccess = await this.checkAndRedirectForClientProduct(d);
        if (!hasAccess) return;

        this.syncClientInUrl(d);
      } catch (err) {
        console.error('[base.vue]: selectedclient switch error', err);
      }
    },
    // Syncs the client dropdown selection from the store.
    // Route/URL sync is handled by the selectedclient watcher above so that
    // FC project pages can navigate to the correct cycle instead of blindly
    // updating the cid on a stale project URL.
    '$store.state.client': function (d) {
      this.selectedclient = d;
    },
    '$store.state.refreshclient': function (d) {
      if (d) this.getDetails();
    },
    '$store.state.containerheight': function (d) {
      this.containerHeight = d + "px";
    },
    '$store.state.navigation': function (d) {
      this.showNavgation = d;
    },
    '$store.state.headeraction': function (d) {
      this.showHeaderAction = d;
    },
    '$store.state.custommenu': function () {
      this.setMenu(this.$route.path);
    },
    '$store.state.permission': function () {
      this.setMenu(this.$route.path);
    },
    '$store.state.mininavbar': function () {
      this.navminivarient = this.$store.state.mininavbar;
      localStorage.setItem("navminivarient", this.navminivarient);
    },
    '$store.state.menu': function () {
      this.findlist()
    },
    navminivarient(val) {
      document.body.classList.toggle('nav-mini', val);
      document.body.classList.toggle('nav-full', !val);
    }
  },
};
</script>

<style scoped>
/* Retained only truly component-specific overrides (currently none). Navigation
   related styles were migrated & tokenized inside `_globals.scss`. */
.nav-img-icon {
  display: inline-block;
  vertical-align: middle;
  object-fit: contain;
}

:deep(.nav-img-icon) {
  filter: brightness(100) saturate(0%);
}

:deep(.logout-icon:hover) {
  /* Hex: #FF4D4D */
  filter: invert(44%) sepia(74%) saturate(2335%) hue-rotate(330deg) brightness(100%) contrast(101%);
}

/* :deep(.v-alert__wrapper) { display: ruby;} */
:deep(.v-alert__icon) {
  align-self: auto;
}

/* Floating component full page styles */
.floating-component-page {
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
  z-index: 1;
}

.floating-component-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.floating-component-content :deep(.chatbot-container) {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
